<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(
              isNew
                ? "CRUD.newInfo"
                : savable
                ? "CRUD.editInfo"
                : "CRUD.viewInfo",
              [$t("WaveRules.ObjectName")]
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("WaveRules.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("WaveRules.Fields.ruler_name") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('WaveRules.Fields.ruler_name')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="waveRuler.name"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'name')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ waveRuler ? waveRuler.name : "" }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("WaveRules.Fields.max_order_count") + $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('WaveRules.Fields.max_order_count')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="waveRuler.max_order_num"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'max_order_num')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ waveRuler ? waveRuler.max_order_num : "" }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("WaveRules.Fields.min_order_count") + $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('WaveRules.Fields.min_order_count')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="waveRuler.min_order_num"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'min_order_num')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ waveRuler ? waveRuler.min_order_num : "" }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("WaveRules.Fields.pick_order_type") + $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('WaveRules.Fields.pick_order_type')"
                    rules="required"
                  >
                    <v-select
                      v-model="waveRuler.add_type"
                      :items="$consts.waveRules.pick_type"
                      item-text="text"
                      item-value="value"
                      unclearable
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'add_type')
                          .concat(errors)
                      "
                      :disabled="waveRuler.status ? true : false"
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ waveRuler.add_type | pickOrderTypesText }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("WaveRules.Fields.pick_order_way") + $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('WaveRules.Fields.pick_order_way')"
                    rules="required"
                  >
                    <v-select
                      v-model="waveRuler.pick_type"
                      :items="$consts.waveRules.pick_way"
                      item-text="text"
                      item-value="value"
                      unclearable
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'pick_type')
                          .concat(errors)
                      "
                      :disabled="waveRuler.status ? true : false"
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ waveRuler.pick_type | pickOrderWaysText }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("WaveRules.Fields.area_split_ruler") + $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('WaveRules.Fields.area_split_ruler')"
                    rules="required"
                  >
                    <v-select
                      v-model="waveRuler.area_split_type"
                      :items="$consts.waveRules.area_split_ruler"
                      item-text="text"
                      item-value="value"
                      unclearable
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'area_split_type')
                          .concat(errors)
                      "
                      :disabled="waveRuler.status ? true : false"
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ waveRuler.area_split_type | areaSplitRulersText }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("WaveRules.Fields.status") + $t("Global.colon") }}
                  <Required :show="savable" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-checkbox
                    v-model="waveRuler.status"
                    :label="$t('WaveRules.status.on')"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <v-chip
                    small
                    label
                    :color="waveRuler.status | waveRulerStatusColor"
                    :text-color="waveRuler.status | waveRulerStatusTextColor"
                  >
                    {{ waveRuler.status | waveRulerStatusText }}
                  </v-chip>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>

      <v-sheet class="page-opts mt-n13">
        <v-card class="">
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="
                    $emit('input', null);
                    $emit('mode', null);
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToList", [$t("WaveRules.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col cols="12" v-if="isView">
                <v-btn
                  color="accent"
                  block
                  :disabled="loading"
                  @click="$emit('mode', 'edit')"
                >
                  <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                  {{ $t("CRUD.editInfo", [$t("WaveRules.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col cols="12" v-if="savable">
                <v-btn
                  color="success"
                  block
                  :disabled="loading"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.saveInfo", [$t("WaveRules.ObjectName")]) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import Required from "@/components/plugins/Required";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import WaveRulers from "@/api/wave_rulers";

export default {
  name: "ShopDetail",

  props: ["value", "mode"],

  components: {
    Required,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    waveRuler: null,
    serverErrors: [],
  }),

  methods: {
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.serverErrors = [];
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            //校验波次生成标准单数
            if (
              this.waveRuler.max_order_num < 0 ||
              this.waveRuler.max_order_num == 0
            ) {
              this.serverErrors.push({
                field: "max_order_num",
                text: "",
                msg: i18n.t("WaveRules.Messages.max_order_count_min"),
              });
            }
            //校验波次生成下限单数
            if (
              this.waveRuler.min_order_num < 0 ||
              this.waveRuler.min_order_num == 0
            ) {
              this.serverErrors.push({
                field: "min_order_num",
                text: "",
                msg: i18n.t("WaveRules.Messages.min_order_count_min"),
              });
            }
            if (
              this.waveRuler.max_order_num &&
              this.waveRuler.min_order_num &&
              (this.waveRuler.max_order_num == this.waveRuler.min_order_num ||
                this.waveRuler.max_order_num < this.waveRuler.min_order_num)
            ) {
              this.serverErrors.push({
                field: "min_order_num",
                text: "",
                msg: i18n.t("WaveRules.Messages.min_order_count_error"),
              });
            }

            if (!this.serverErrors.length) {
              WaveRulers.save(this.waveRuler.id, this.waveRuler)
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.$emit("save", this.waveRuler);
                      this.$emit("mode", null);
                      this.$emit("input", null);
                      this.$refs.observer.reset();
                      this.$store.dispatch("fullscreenLoadingStop");
                    } else if (
                      response.data.error &&
                      response.data.error.data
                    ) {
                      this.$store.dispatch("fullscreenLoadingStop");
                      this.serverErrors = response.data.error.data;
                    }
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            } else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.serverErrors = []; //重置远端错误提示
        if (this.value && this.value.id) {
          WaveRulers.fetchOne(this.value.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.waveRuler = response.data.wave_ruler;
              }
            }.bind(this)
          );
        } else {
          // 新建，初始化默认值
          this.waveRuler = {
            stock_id: this.$route.query.stock_id,
            add_type: 1,
            pick_type: 1,
            area_split_type: 1,
            status: 1,
          };
        }
        this.$scrollTop(); //返回顶部
      },
    },
  },
};
</script>
